import React, {Component} from 'react';
import {injectIntl} from "react-intl";
import Preview from "./Preview"
import {preview} from "../common/preview";
import {fileSizeCheck, typeCheck} from "../common/checks";
import {setImage, setVideo} from "../common/compress";
import {Button, Modal, Progress, Tooltip} from "antd";
import {switchStorageUnit2} from "../common/utils";
import Emitter from "../eventBus.js";
import {connect} from "react-redux";
import {getStatus, upload} from "../common/api";
import {t} from "../utils/i18n";
import {enquireScreen} from "enquire-js";

let isMobile;

enquireScreen((b) => {
    isMobile = b;
});

class Upload extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            file: null,
            isDragging: false,
            uploading: false,
            percentage: 0,
        }
        this.filesInput = null;
    }


    showModal = async () => {
        let filesCount;
        let {currentAccount} = this.props;
        if (!currentAccount) {
            Emitter.emit('showMessageModal', {source: 'login'});
            return;
        }

        let data = await getStatus(currentAccount);
        filesCount = data['file_count'];

        if (filesCount >= 30) {
          Emitter.emit("showMessageModal", { source: "limit" });
        } else {
          this.setState({
            visible: true,
          });
        }
    };

    handleOk = e => {
        this.setState({
            visible: false,
        });
    };

    handleCancel = e => {
        this.setState({
            visible: false,
        });
        let {file} = this.state;
        preview(file, true);
        this.setState({file: null, uploading: false, percentage:0});
        this.filesInput = null;
        document.getElementById('file-input').value = null
    };

    onAddFile = async (e) => {
        e.preventDefault();
        this.filesInput.click();
    }

    onInputChange = () => async () => {
        try {
            let file = this.filesInput.files[0];
            console.log(file);
            this.setState({file: file});
            setTimeout(() => {
                preview(file);
            }, 100)
        } catch (e) {
        }
    }

    upload = async () => {
        let {currentAccount} = this.props;
        let {uploading, file} = this.state;
        if (fileSizeCheck(file)) {
            return;
        }
        if(typeCheck(file)) {
            return;
        }

        if (!uploading) {
            try {
                this.setState({uploading: true});

                let result;
                if (file.type.indexOf('image') > -1) {
                    result = await setImage(URL.createObjectURL(file), 50, 50);
                }
                if (file.type.indexOf('video') > -1) {
                    result = await setVideo(50, 50);
                }

                let config = {
                    onUploadProgress: (progress) => {
                        console.log(Math.round(progress.loaded / progress.total * 100) + '%');
                        this.setState({percentage: Math.round(progress.loaded / progress.total * 100)});
                    }
                }

                let feedback = await upload(file, currentAccount, result, config);

                if (feedback) {
                    if(this.props.refresh) {this.props.refresh();}
                    Emitter.emit('showMessageAlert', {message: 'upload_successful', status: 'success'});
                } else {
                    Emitter.emit('showMessageAlert', {message: 'upload_failed', status: 'error'});
                }
                this.handleCancel();

            } catch (e) {
                Emitter.emit('showMessageAlert', {message: 'upload_failed', status: 'error'});
                this.handleCancel();
            }
        }
    }

    onDragOver = (e) => {
        this.setState({isDragging: true});
        e.preventDefault();
    }

    onDragLeave = (e) => {
        this.setState({isDragging: false});
        e.preventDefault();
    }

    onDrop = (e) => {
        e.preventDefault()
        if (e.dataTransfer.items) {
            const fls = []
            // Use DataTransferItemList interface to access the file(s)
            for (let i = 0; i < e.dataTransfer.items.length; i++) {
                // If dropped items aren't files, reject them
                if (e.dataTransfer.items[i].kind === 'file') {
                    const fl = e.dataTransfer.items[i].getAsFile()
                    if (fl) fls.push(fl)
                }
            }
            if (fls.length === 1) {
                let file = fls[0];
                this.setState({file: file});
                setTimeout(() => {
                    preview(file);
                }, 100)
            }
        } else {
            // Use DataTransfer interface to access the file(s)
            let file = e.dataTransfer.files[0];
            if (e.dataTransfer.files.length === 1) this.setState({file: file});
            setTimeout(() => {
                preview(file);
            }, 100)
        }
        this.setState({isDragging: false});
    }

    render() {
        let {intl} = this.props;
        let {file, isDragging, uploading, percentage} = this.state;
        return (<div className="m-auto text-center">

            <Button type="primary" onClick={this.showModal} className='upload_button'>
                <i className="iconfont icon-UPLOAD mr-3"></i>
                {t('upload')}
            </Button>

            <Modal
                visible={this.state.visible}
                centered={isMobile ? false : true}
                maskClosable={false}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                footer={null}
                style={{width: '600px !important'}}
                wrapClassName={'upload_modal'}
            >

                <div style={{width: '100%', height: '100%'}} onDragOver={this.onDragOver} onDrop={this.onDrop}>
                    <>
                        {isDragging && (
                            <div onDragLeave={this.onDragLeave}
                                 className="flex justify-center items-center text-4xl text-center text-white bg-green-900 absolute top-0 left-0 w-full h-full inset-0 z-40">
                                Drop it to select.
                            </div>
                        )}
                    </>

                    <div
                        className="w-full h-full flex items-center flex-col justify-between items-center ml-auto mr-auto"
                        style={{maxWidth: '600px'}}>
                        <div>
                            <div className='title'>{t('upload')}</div>
                            <div className="text-center">
                                {
                                    !file && <>
                                        <div className=" description">
                                            {t('upload_description1')}
                                        </div>
                                    </>
                                }
                                {
                                    file && <>
                                        <div className=" description">
                                            {t('upload_double_check')}
                                        </div>
                                    </>
                                }
                            </div>
                        </div>

                        <div className="mt-2 w-full relative overflow-auto flex justify-center outer_preview">
                            {file && <Preview file={file}/>}

                        </div>

                        {
                            file && <div className="mt-2 file_info w-full">
                                {
                                    <div>
                                        <div className="flex p-2">
                                            <span>{t('file_name')}: &nbsp;</span>
                                            <strong>{file.name}</strong>
                                        </div>
                                        <div
                                            className={"flex p-2 " + (fileSizeCheck(file) ? 'text-red-500' : '')}>
                                            <span>{t('size')}: &nbsp;</span>
                                            <strong>{switchStorageUnit2(file.size)}</strong>

                                            {fileSizeCheck(file) && <Tooltip
                                                title={intl.formatMessage({id: 'size_warning'})}>
                                                <i className="fas fa-exclamation-triangle text-red-500 ml-2 mt-1"></i>
                                            </Tooltip>}

                                        </div>
                                        <div
                                            className={"flex p-2 " + (typeCheck(file) ? 'text-red-500' : '')}>
                                            <span>{t('type')}: &nbsp;</span>
                                            <strong>{file.type}</strong>
                                            {typeCheck(file) && <Tooltip
                                                title={intl.formatMessage({id: 'type_not_supported'})}>
                                                <i className="fas fa-exclamation-triangle text-red-500 ml-2 mt-1"></i>
                                            </Tooltip>}
                                        </div>
                                    </div>
                                }
                            </div>
                        }

                        <div className="text-center mt-6 w-full ">
                            {
                                !file && <>
                                    <div className="p-4  description">
                                        {t('upload_type')} JPG, PNG, GIF, SVG, PDF, JSON, MP4, MP3, {t('etc')}
                                        <br/>
                                        {t('upload_description2')}
                                    </div>
                                    <button
                                        className="bt_text bg-indigo-500 text-white active:bg-indigo-600 text-sm font-bold uppercase px-6 py-6 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={this.onAddFile}
                                    >
                                        <i className="fas fa-plus float-left text-lg"></i>
                                        {t('add')}
                                    </button>
                                </>
                            }

                            {
                                file && <button
                                    className={"bt_text text-white text-sm font-bold uppercase px-6 py-6 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150 " + (uploading ? "bg-gray-500 cursor-wait" : "bg-indigo-500 active:bg-indigo-600")}
                                    type="button"
                                    onClick={this.upload}
                                >
                                    <i className="fas fa-plus float-left text-lg"></i>
                                    {t('upload')}
                                </button>
                            }

                            {uploading && <Progress percent={percentage} status="active"/>}

                        </div>

                    </div>

                    <input
                        id='file-input'
                        type='file'
                        className='hidden'
                        accept="image/*, video/*, audio/*, application/*, .doc"
                        ref={el => {
                            this.filesInput = el
                        }}
                        onChange={this.onInputChange()}
                    />
                </div>

            </Modal>
        </div>);
    }
}

function mapStateToProps(state) {
    return {
        currentAccount: state.app.currentAccount
    };
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Upload));
